import { render } from "./RegularToolbarItem.vue?vue&type=template&id=8b684670&scoped=true&ts=true"
import script from "./RegularToolbarItem.vue?vue&type=script&lang=ts"
export * from "./RegularToolbarItem.vue?vue&type=script&lang=ts"

import "./RegularToolbarItem.vue?vue&type=style&index=0&id=8b684670&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b684670"]])

export default __exports__